import React, { Component } from 'react';
import { connect } from 'react-redux';
import TobaList from "../../components/Tobas/tobaList";
import {deleteToba, getTobas} from "../../actions/tobas";
import {requestGetGroupsOfSolicitors} from "../../actions/groups";
import { push } from 'connected-react-router';
// import { push } from 'react-router-redux';
import CustomCheckbox from "../../components/General/customCheckbox";
import {changeTobaListStoreSettings, tobasListPageShift} from "../../actions/tobaList";
import _ from 'lodash';
import Button from "../../components/button";
import {getTobaRevisions} from "../../actions/toba";
import moment from "moment";
import { LEGAL_ADVICE_TEXT, TOBA_PATH } from '../../helpers/variables';
class TobaListHOC extends Component {

  componentDidMount() {
    let calcOffset =this.props.tobaList.displayAmount*(this.props.tobaList.page -1);
    this.props.getTobas(
        {
          limit: this.props.tobaList.displayAmount,
          offset: calcOffset>0? calcOffset:0,
        }
    );
  }

  componentWillReceiveProps(nextProps){
    if(
        (this.props.tobaList.page !== nextProps.tobaList.page ||
            this.props.tobaList.displayAmount !== nextProps.tobaList.displayAmount) &&
        (!this.props.fetchingTobas)
    ){
      let totalDisplayBoxes = Math.ceil(nextProps.tobaList.totalRecords / parseInt(nextProps.tobaList.displayAmount));
      let currentPage = parseInt(nextProps.tobaList.page);
      if(currentPage > totalDisplayBoxes){
        currentPage = totalDisplayBoxes;
      }


      let calcOffset =nextProps.tobaList.displayAmount*(currentPage -1);
      this.props.getTobas(
          {
            limit: nextProps.tobaList.displayAmount,
            offset: calcOffset>0? calcOffset:0,
          }
      );
    }
    if(this.props.postingToba && !nextProps.postingToba){
      let totalDisplayBoxes = Math.ceil(nextProps.tobaList.totalRecords / parseInt(nextProps.tobaList.displayAmount));
      let currentPage = parseInt(nextProps.tobaList.page);
      if(currentPage > totalDisplayBoxes){
        currentPage = totalDisplayBoxes;
      }


      let calcOffset =nextProps.tobaList.displayAmount*(currentPage -1);
      this.props.getTobas(
          {
            limit: nextProps.tobaList.displayAmount,
            offset: calcOffset>0? calcOffset:0,
          }
      );
    }
  }

  _getTableHeaders = () => {
    return [
      {
        key: 'checkbox',
        value: <CustomCheckbox
            name={"allTobasSelected"}
            checked={this.props.tobaList.allTobasSelected}
            label=""
            _onChange={this._handleAllRowsSelect}
        />,
        style: 'col-sm-1'
      },
      {
        key: 'name',
        value: 'Name',
        style: 'col-sm-4'
      },
      {
        key: 'version',
        value: 'Version',
        style: 'col-sm-3'
      },
      {
        key: 'solicitorGroups',
        value: 'Solicitor Groups',
        style: 'col-sm-4'
      },
    ]
  };

  //function that handles all rows select
  _handleAllRowsSelect = (evt) => {
    if(evt.target.checked) {
      let s = {};
      _.forEach(this.props.tobas, (toba, index) => {
        if(toba.solicitorGroupDtos.length > 0){
          s = {...s, [toba.id]: toba}
        }
      });
      this.props.changeStoreSettings('selectedTobas', s);
    }
    else {
      this.props.changeStoreSettings('selectedTobas', {})
    }
    this.props.changeStoreSettings('allTobasSelected', evt.target.checked)
  };

  //function that handles row select from the toba table
  _handleRowSelect = (key, row) => {
    let currentSelectedRows = {...this.props.tobaList.selectedTobas};
    if(currentSelectedRows.hasOwnProperty(key)){
      delete currentSelectedRows[key];
      this.props.changeStoreSettings('selectedTobas', currentSelectedRows);
      if(this.props.tobaList.allTobasSelected){
        this.props.changeStoreSettings('allTobasSelected', false)
      }
    }
    else {
      this.props.changeStoreSettings('selectedTobas', {
        ...currentSelectedRows,
        [key]: row
      })
    }
  };

  //function that returns true if the row is checked
  _isRowChecked = (key) => {
    if(this.props.tobaList.selectedTobas.hasOwnProperty(key)){
      return true;
    }
    else {
      return false;
    }
  };

  _handleSelectChange = (evt) => {
    this.props.changeStoreSettings(evt.target.name, evt.target.value)
  };

  //action handler
  _handleApplyButton = () => {
    if(Object.keys(this.props.tobaList.selectedTobas).length === 0) {
      return 0;
    }
    if(this.props.tobaList.deleting){
      return 0;
    }
    if(this.props.tobaList.selectedAction === 'delete'){
      this.props.changeStoreSettings('deleteModalOpen', true)
    }
  };

  //closes the modal
  _closeModal = () => {
    this.props.changeStoreSettings('deleteModalOpen', false)
  };

  _getDeleteModalContent = () => {
    let content ;
    content = <div>
      <p>You are about to <b>delete</b> the following TOBA's</p>
      {_.map(this.props.tobaList.selectedTobas, (t, index) => {
        return (
            <div key={index}>{t.name + ' - '}
              <span
                  onClick={() => this._viewTobaSolicitorGroupsInModal(t.id)}
                  className="toba__delete-modal__toba-view-groups"
              >
                      View Solicitor Groups attached to this TOBA
                  </span>
            </div>
        )
      })}
      <p><b>Are you sure?</b></p>
      <Button clickHandler={this._deleteSelectedTobas} wrapper="btn-wrapper"
              btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
              label="Yes"/>
      <Button clickHandler={this._closeModal} wrapper="btn-wrapper"
              btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'}
              label="No"/>
    </div>;
    return content;
  };

  _deleteSelectedTobas = () => {
    _.forEach(this.props.tobaList.selectedTobas, toba => {
      this.props.deleteToba(toba.id)
    })
  };

  //closes the toba form modal
  _closeTobaFormModal = () => {
    this.props.changeStoreSettings('tobaFormModalOpen', false)
  };

  //opens the toba form modal
  _openTobaFormModal = () => {
    this.props.changeStoreSettings('tobaFormModalOpen', true)
  };

  _onRowClick = (evt, tobaId, tobaName) => {
    if(evt.button === 1){
      window.open(`/solicitors/${TOBA_PATH}s` + tobaId, '_blank');
    } else {
      this.props.push( `/solicitors/${TOBA_PATH}s` + tobaId);
    }
  };

  //function that opens modal with the sol groups of the selected toba
  _viewTobaSolicitorGroupsInModal = (tobaId) => {
    this.props.changeStoreSettings('openTobaGroupDetailsModal', true);
    this.props.changeStoreSettings('selectedTobaToSeeGroups', tobaId);
  };

  //closes the toba solicitor groups modal
  _closeTobaSolicitorGroupsModal = () => {
    this.props.changeStoreSettings('openTobaGroupDetailsModal', false);
    this.props.changeStoreSettings('selectedTobaToSeeGroups', '');
  };

  _tobaSolicitorGroupsDetailsModalContent = () => {
    if(this.props.tobaList.selectedTobaToSeeGroups){
      let toba = _.find(this.props.tobas, t => {return t.id === this.props.tobaList.selectedTobaToSeeGroups});
      if(toba){
        return (
            <div>
              <p><b>name: </b><span>{toba.name}</span></p>
              <p><b>{LEGAL_ADVICE_TEXT} Groups: </b>
                <ul>
                  {
                    toba.solicitorGroupDtos.map(d => {
                      return <li key={d.id}>{d.name} {moment(d.startDate).format("DD/MM/YYYY, h:mm:ss a")} - {d.expiryDate!==null?moment(d.expiryDate).format("DD/MM/YYYY, h:mm:ss a"):null}</li>
                    })
                  }
                </ul>
              </p>
            </div>
        )
      }
      else {
        return '';
      }
    }
    else return '';
  };

  onListItemSelect = (checked, rowIndex, row) => {
    let selectedItems = {};
    if (checked) {
      selectedItems = { ...this.props.tobaList.selectedTobas, [rowIndex]: row }

    } else {
      selectedItems = _.omit(this.props.tobaList.selectedTobas, [rowIndex]);
    }

    this.props.changeStoreSettings('selectedTobas', selectedItems);
  };

  onSelectAllItems = (checked) => {
    let selectedTobas = {};
    if (checked) {
      this.props.tobas.forEach((claim, index) => {
        selectedTobas = { ...selectedTobas, [index]: claim };
      });
    }

    this.props.changeStoreSettings('selectedTobas', selectedTobas);
  };

  render(){
    return(
        <TobaList
            onListItemSelect={this.onListItemSelect}
            onSelectAllItems={this.onSelectAllItems}
            tobaSolicitorGroupsDetailsModalContent={this._tobaSolicitorGroupsDetailsModalContent()}
            _viewTobaSolicitorGroupsInModal={this._viewTobaSolicitorGroupsInModal}
            _closeTobaSolicitorGroupsModal={this._closeTobaSolicitorGroupsModal}
            _onRowClick={this._onRowClick}
            fetchingTobas={this.props.fetchingTobas}
            _handleStoreChange={this.props.changeStoreSettings}
            _pageShift={this.props.pageShift}
            _openTobaFormModal={this._openTobaFormModal}
            _closeTobaFormModal={this._closeTobaFormModal}
            _getDeleteModalContent={this._getDeleteModalContent}
            _closeModal={this._closeModal}
            _handleApplyButton={this._handleApplyButton}
            _handleSelectChange={this._handleSelectChange}
            _isRowChecked={this._isRowChecked}
            tobaList={this.props.tobaList}
            _handleRowSelect={this._handleRowSelect}
            _pushRoute={this.props.push}
            headers={this._getTableHeaders()}
            tobas={this.props.tobas}
            solicitorGroups={this.props.solicitorGroups}
        />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    tobaList: state.tobaList,
    tobas: state.tobas.tobas,
    fetchingTobas: state.tobas.fetching,
    solicitorGroups: state.groups.solicitorGroups,
    postingToba: state.toba.posting
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTobas: (parameters) => {
      dispatch(getTobas(parameters))
    },
    getSolicitorGroups: () => {
      dispatch(requestGetGroupsOfSolicitors())
    },
    push: (url) => {
      dispatch(push(url))
    },
    changeStoreSettings: (key, value) => {
      dispatch(changeTobaListStoreSettings(key, value))
    },
    deleteToba: (tobaId) => {
      dispatch(deleteToba(tobaId))
    },
    pageShift: (direction) => {
      dispatch(tobasListPageShift(direction))
    },
    getTobaRevisions: (payload) => {
      dispatch(getTobaRevisions(payload))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(TobaListHOC);